export const DARK_THEME = 'dark';
export const LIGHT_THEME = 'light';
export const HOME_ROUTE = '/';
export const LOGIN_ROUTE = '/login';
export const SEARCH_MOVIE_ROUTE = '/search-movie';
export const MOVIE_DETAILS_ROUTE = '/movies/';
export const UPCOMING_MOVIES_ROUTE = '/upcoming-movies';
export const POPULAR_MOVIES_ROUTE = '/popular-movies';
export const TOP_RATED_MOVIES_ROUTE = '/top-rated-movies';
export const NOT_FOUND_ROUTE = '*';
export const AUTHORIZED_ROUTE = [
  HOME_ROUTE,
  MOVIE_DETAILS_ROUTE,
  NOT_FOUND_ROUTE,
];
export const INVALID_CREDENTIALS =
  'Invalid credentials. Please check the email and password.';
export const USER_AVATAR = '/avatar.png';
export const NOT_FOUND_IMG = '/404-computer.png';
export const YOUTUBE_VIDEO_URL = 'https://www.youtube.com/embed/';
export const MOVIE_URL = 'https://api.themoviedb.org/3/movie/';
export const TMDB_URL = 'https://api.themoviedb.org/3/';
export const API_OPTIONS = {
  method: 'GET',
  headers: {
    accept: 'application/json',
    Authorization: `Bearer ${process.env.REACT_APP_TMDB_API_KEY}`,
  },
};
export const NOW_PLAYING_MOVIES = {
  url: 'movie/now_playing',
  value: 'Now Playing',
};
export const POPULAR_MOVIES = { url: 'movie/popular', value: 'Popular Movies' };
export const TOP_RATED_MOVIES = {
  url: 'movie/top_rated',
  value: 'Top Rated Movies',
};
export const UPCOMING_MOVIES = {
  url: 'movie/upcoming',
  value: 'Upcoming Movies',
};
export const SEARCH_MOVIE = {
  url: 'search/movie',
  value: 'Search Movie',
};
export const TMDB_IMAGE_URL = 'https://image.tmdb.org/t/p/w500';
export const DEFAULT_IMAGE_URL = '/default_poster.jpg';
export const NO_RESULT_FOUND = 'No Result Found!';
